import React from 'react';
import { Link } from 'react-router-dom';

export default function ParentChildItem({data, srNo}) {
  return (
    <tr>
        <td>
            {srNo}
        </td>
        <td>
            {data.firstName+' '+data.lastName}
        </td>
        <td>
            {data.dob}
        </td>
        <td>
            <Link to={`/children/${data.childId}`} className='link-btn link-font-size'>View</Link>
        </td>
    </tr>
  )
}
